
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services-sitemap.xml",
      function () {
        return require("private-next-pages/services-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services-sitemap.xml"])
      });
    }
  